export const dates = [
  {
    startDate: '2020-01-01T00:00:00.000Z',
    endDate: '2020-12-31T23:59:59.999Z',
  },
  {
    startDate: '2020-01-01T00:00:00.000Z',
    endDate: '2020-03-31T23:59:59.999Z',
  },
  {
    startDate: '2020-04-01T00:00:00.000Z',
    endDate: '2020-06-30T23:59:59.999Z',
  },
  {
    startDate: '2020-07-01T00:00:00.000Z',
    endDate: '2020-09-30T23:59:59.999Z',
  },
  {
    startDate: '2020-10-01T00:00:00.000Z',
    endDate: '2020-12-31T23:59:59.999Z',
  },
  {
    startDate: '2020-01-01T00:00:00.000Z',
    endDate: '2020-06-30T23:59:59.999Z',
  },
  {
    startDate: '2020-07-01T00:00:00.000Z',
    endDate: '2020-12-31T23:59:59.999Z',
  },
];

export const quarter_week: any = {
  0: [
    '2023_W27',
    '2023_W28',
    '2023_W29',
    '2023_W30',
    '2023_W31',
    '2023_W32',
    '2023_W33',
    '2023_W34',
    '2023_W35',
    '2023_W36',
    '2023_W37',
    '2023_W38',
    '2023_W39',
  ],
  1: [
    '2023_W27',
    '2023_W28',
    '2023_W29',
    '2023_W30',
    '2023_W31',
    '2023_W32',
    '2023_W33',
    '2023_W34',
    '2023_W35',
    '2023_W36',
    '2023_W37',
    '2023_W38',
    '2023_W39',
  ],
  2: [
    '2023_W40',
    '2023_W41',
    '2023_W42',
    '2023_W43',
    '2023_W44',
    '2023_W45',
    '2023_W46',
    '2023_W47',
    '2023_W48',
    '2023_W49',
    '2024_W50',
    '2024_W51',
    '2024_W52',
  ],
  3: [
    '2024_W1',
    '2024_W2',
    '2024_W3',
    '2024_W4',
    '2024_W5',
    '2024_W6',
    '2024_W7',
    '2024_W8',
    '2024_W9',
    '2024_W10',
    '2024_W11',
    '2024_W12',
    '2024_W13',
  ],
  4: [
    '2024_W14',
    '2024_W15',
    '2024_W16',
    '2024_W17',
    '2024_W18',
    '2024_W19',
    '2024_W20',
    '2024_W21',
    '2024_W22',
    '2024_W23',
    '2024_W24',
    '2024_W25',
    '2024_W26',
  ],
};

export const maxValList = [
  {
    //at
    fullYearMax: 23.74,
    fullYearMin: 0.0,
    quarterMax: 100,
    quarterMin: 0.92,
  },
  {
    //ca
    fullYearMax: 2.0,
    fullYearMin: 0.0,
    quarterMax: 4.0,
    quarterMin: 1.0,
  },
  {
    //mts
    fullYearMax: 36.75,
    fullYearMin: 0.0,
    quarterMax: 50.67,
    quarterMin: 0.0,
  },
  {
    //med
    fullYearMax: 91.07,
    fullYearMin: 18.75,
    quarterMax: 100.0,
    quarterMin: 18.75,
  },
  {
    //twc
    fullYearMax: 69.3,
    fullYearMin: 5.0,
    quarterMax: 109.25,
    quarterMin: 0.75,
  },
];

export const quartersWithData: any = {
  '2024': true,
  Q1: true,
  Q2: true,
  Q3: true,
  Q4: true,
};

export const outComeDropdownValues = [
  {
    value: 'Win Rate',
    label: 'Accounts Growth %',
  },
  {
    value: 'Deal Size',
    label: 'Cross Selling Revenue (Amount)',
  },
  {
    value: 'Quota Attainment',
    label: 'Deposits Growth %',
  },
  // {
  //   value: 'Sales Cycle',
  //   label: 'Sales Cycle (Days)'
  // },
];

export const roleName: { [key: string]: string } = {
  ADMIN: 'Admin',
  LEADER: 'Manager',
  AE: 'Rep',
  EXEC: 'Exec',
};

export const personaList = [
  {
    value: 'ADMIN',
    name: 'Admin',
  },
  {
    value: 'LEADER',
    name: 'Manager',
  },
  {
    value: 'AE',
    name: 'Rep',
  },
  {
    value: 'EXEC',
    name: 'Exec',
  },
  {
    value: 'SDR',
    name: 'SDR',
  },
];

export const fiveBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Middle</span><span style="display:flex;justify-content:center;">Performer</span></div>',
  '3':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '4':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const threeBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Middle</span><span style="display:flex;justify-content:center;">Performer</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const fourBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '3':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const fiveBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Below Average - Performers',
  '3': 'Mid-Performers',
  '4': 'High-Performers',
  '5': 'Out-Performers',
};

export const fourBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Mid-Performers',
  '3': 'High-Performers',
  '4': 'Out-Performers',
};
export const threeBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Mid-Performers',
  '3': 'High-Performers',
};

export const percentageDrivers = [
  'Total Connects / Attempts',
  'Future Interest / Connects',
  'Followups / Connects',
  'Meetings Rescheduled / Connects',
];

export const colorCode = [
  { primary: 'rgb(224, 69, 50)', secondary: 'rgb(224  69  50 / 20%)' },
  { primary: 'rgb(242, 113, 69)', secondary: 'rgb(242  113  69 / 20%)' },
  { primary: 'rgb(245, 126, 75)', secondary: 'rgb(245  126  75 / 20%)' },
  { primary: 'rgb(251, 162, 93)', secondary: 'rgb(251  162  93 / 20%)' },
  { primary: 'rgb(166, 217, 111)', secondary: 'rgb(166  217  111 / 20%)' },
  { primary: 'rgb(163, 216, 110)', secondary: 'rgb(163  216  110 / 20%)' },
  { primary: 'rgb(154, 212, 107)', secondary: 'rgb(154  212  107 / 20%)' },
  { primary: 'rgb(156, 213, 108)', secondary: 'rgb(156  213  108 / 20%)' },
  { primary: 'rgb(136, 204, 103)', secondary: 'rgb(136  204  103 / 20%)' },
  { primary: 'rgb(116, 195, 100)', secondary: 'rgb(116  195  100 / 20%)' },
  { primary: 'rgb(128, 200, 102)', secondary: 'rgb(128  200  102 / 20%)' },
  { primary: 'rgb(124, 199, 101)', secondary: 'rgb(124  199  101 / 20%)' },
  { primary: 'rgb(251, 160, 92)', secondary: 'rgb(251  160  92 / 20%)' },
  { primary: 'rgb(15, 130, 68)', secondary: 'rgb(15  130  68 / 20%)' },
  { primary: 'rgb(60, 167, 88)', secondary: 'rgb(60  167  88 / 20%)' },
  { primary: 'rgb(59, 167, 87)', secondary: 'rgb(59  167  87 / 20%)' },
  { primary: 'rgb(69, 173, 90)', secondary: 'rgb(69  173  90 / 20%)' },
  { primary: 'rgb(88, 182, 95)', secondary: 'rgb(88  182  95 / 20%)' },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(241, 111, 68)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(241  111  68 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(250, 158, 91)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(250  158  91 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(125, 199, 101)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(125  199  101 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  { primary: 'rgb(0, 104, 55)', secondary: 'rgb(0  104  55 / 20%)' },
  { primary: 'rgb(229, 80, 54)', secondary: 'rgb(229  80  54 / 20%)' },
];

export const activeNudges = [
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Prioritise selling activities',
    primary_driver: 'Time with Customer',
    actionCompleteDate: '2024-05-11T23:16:03.024Z',
    createdDate: '2024-02-11T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Meet with Manager weekly',
    primary_driver: 'Manager RM 1:1 Frequency',
    actionCompleteDate: '2024-04-30T05:09:24.294Z',
    createdDate: '2024-01-30T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Reduce response time',
    primary_driver: 'Follow-up with Customer',
    actionCompleteDate: '2024-04-13T17:13:11.098Z',
    createdDate: '2024-01-13T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  }
];

export const json = [
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    activity: 'Enhance frequency of engagement',
    primary_driver: 'Relationship Depth',
    due_date: '2024-05-26T15:27:26.281Z',
    nudgeDate: '2023-04-04',
    doneDate: '2023-05-04',
    impact: 'Score Increase: 2 >> 4',
    outcome: 'Accounts Growth',
    outcomeTrackerChartData: [
      {
        xAxis: '2023 Q1',
        value: 14,
        nudge: '',
      },
      {
        xAxis: '2023 Q2',
        value: 16,
        nudge: 'DONE DATE',
      },
      {
        xAxis: '2023 Q3',
        value: 19,
        nudge: '',
      },
      {
        xAxis: '2023 Q4',
        value: 19,
        nudge: '',
      },
      {
        xAxis: '2024 Q1',
        value: 21,
        nudge: '',
      },
      {
        xAxis: '2024 Q2',
        value: 23,
        nudge: '',
      },
    ],
  },
  // {
  //   userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
  //   activity: 'Product training - Advanced',
  //   primary_driver: 'Product knowledge / Bundling score',
  //   due_date: '2024-05-26T15:27:26.281Z',
  //   nudgeDate: '2023-04-27',
  //   doneDate: '2023-07-27',
  //   impact: 'Score Increase : 30 >> 60',
  //   outcome: 'Cross Selling Revenue',
  //   outcomeTrackerChartData: [
  //     {
  //       xAxis: '2023 Q1',
  //       value: 55, // $115K
  //       value1: 115,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2023 Q2',
  //       value: 55, // $115K
  //       value1: 115,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2023 Q3',
  //       value: 60, // $125K
  //       value1: 125,
  //       nudge: 'DONE DATE',
  //     },
  //     {
  //       xAxis: '2024 Q4',
  //       value: 75, // $125K
  //       value1: 150,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2024 Q1', // $150K
  //       value: 75,
  //       value1: 150,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2024 Q2', // $150K
  //       value: 80,
  //       value1: 165,
  //       nudge: '',
  //     },
  //   ],
  // },
];

export const lindy_theo = {
  battleCard: [
    {
      name: 'Lindy Panner',
      userId: 'b451a638-1262-41c7-9557-8fa4bdf57a2f',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Product Knowledge / Bundling Score',
          value: 30.0,
          valueType: 'continuous',
          original_top_driver: 'Months in role',
          predicted_outcome: '773622.75',
          org_driver_mean_value: 36.8,
          X_poor_org_driver_value: 55,
          X_good_org_driver_value: 51,
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'With Customer',
          value: 33,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-up With Customers',
          value: 11,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to focus on activities that matter',
          actionName:
            '<b style="font-weight:500">Lindy</b>, you have a unique opportunity to elevate your impact by leveraging Business Banking’s full suite to create tailored, comprehensive solutions for your customers.',
          actionName1:
            'RMs with an average score of 60+ on Product Knowledge consistently achieve 15% higher Cross Selling Revenue.',
          actionName2:
            'By focusing on strategic product bundling, you can double your Product Bundling Score from 30 to 60, unlocking an estimated $30K in Cross Selling Revenue next quarter.',
          course: 'Product Bundling Score',
          driverDefinition: '',
        },
      ],
      title: 'Activity',
      battleCardType: 'Activity Battlecards',
      driver1_max_value: 93,
      driver2_max_value: 49,
      driver3_max_value: 21,
      driver1_min_value: 58.15,
      driver2_min_value: 6,
      driver3_min_value: 0,
      driver1_mean_value: 60.4,
      driver2_mean_value: 33.7,
      driver3_mean_value: 12.7,
      org_driver_max_value: 107,
      org_driver_min_value: 0,
    },
    {
      name: 'Theodora McCambridge',
      userId: 'Theodora McCambridge',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Product Knowledge / Bundling Score',
          value: 86.0,
          valueType: 'continuous',
          original_top_driver: 'Months in role',
          predicted_outcome: '773622.75',
          org_driver_mean_value: 36.8,
          X_poor_org_driver_value: 55,
          X_good_org_driver_value: 51,
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'With Customer',
          value: 40,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-up With Customers',
          value: 19,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Activity Battlecards',
      driver1_max_value: 93,
      driver2_max_value: 49,
      driver3_max_value: 21,
      driver1_min_value: 58.15,
      driver2_min_value: 6,
      driver3_min_value: 0,
      driver1_mean_value: 60.4,
      driver2_mean_value: 33.7,
      driver3_mean_value: 12.7,
      org_driver_max_value: 107,
      org_driver_min_value: 0,
    },
  ],
};

export const leann_amelia = {
  battleCard: [
    {
      name: 'Leann Pestridge',
      userId: '9998460c-be73-4e96-87aa-f6393c268a4c',
      battleCardData: [
        {
          name: 'High Engagement Customers (%)',
          value: 22,
          valueType: 'continuous',
          title: 'Activity',
          original_top_driver: 'Months in role',
          predicted_outcome: '11.97',
          org_driver_mean_value: 36.8,
          X_poor_org_driver_value: 37,
          X_good_org_driver_value: 29,
        },
        {
          title: 'Activity',
          name: 'Product Knowledge / Bundling Score',
          value: 47,
          valueType: 'continuous',
        },
        {
          title: 'Time Allocation',
          name: 'With Product Team',
          value: 7.5,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to spend more time w/ customers',
          actionName:
            '<b>Leann</b>, engaging in more frequent client conversations is your accelerator for Accounts Growth.',
          actionName1:
            'RMs with 45%+ of customers in regular meetings see 20% higher Accounts Growth.',
          actionName2:
            'By doubling your rate to 45%, you could drive up Accounts Growth to 14% next quarter.',
          course: 'High Engagement Customers (%)',
        },
      ],
      title: 'Activity',
      battleCardType: 'Activity Battlecards',
      driver1_max_value: 100,
      driver2_max_value: 93,
      driver3_max_value: 30.75,
      driver1_mean_value: 45,
      driver2_mean_value: 60.41,
      driver3_mean_value: 13.26,
    },
    {
      name: 'Amelia Spino',
      userId: 'Amelia Spino',
      battleCardData: [
        {
          name: 'High Engagement Customers (%)',
          value: 76,
          valueType: 'continuous',
          title: 'Activity',
        },
        {
          title: 'Activity',
          name: 'Product Knowledge / Bundling Score',
          value: 73,
          valueType: 'continuous',
        },
        {
          title: 'Time Allocation',
          name: 'With Product Team',
          value: 16.17,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Activity Battlecards',
      driver1_max_value: 100,
      driver2_max_value: 93,
      driver3_max_value: 30.75,
      driver1_mean_value: 45,
      driver2_mean_value: 60.41,
      driver3_mean_value: 13.26,
    },
  ],
};

export const gly_ste = {
  battleCard: [
    {
      name: 'Glynnis Houlston',
      userId: '20b3649f-7e87-4972-8011-8651794b6aef',
      battleCardData: [
        {
          title: 'Competencies',
          name: 'Relationship Depth',
          value: 1.5,
          valueType: 'discrete',
          original_top_driver: 'Technical Skills',
          predicted_outcome: '41.92',
          org_driver_mean_value: 3.45,
          X_poor_org_driver_value: 1.5,
          X_good_org_driver_value: 4,
        },
        {
          title: 'Activity',
          name: 'Product Knowledge / Bundling Score',
          value: 32,
          valueType: 'continuous',
        },
        {
          title: 'Time Allocation',
          name: 'With Customer',
          value: 12.73,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to take next course',
          actionName:
            '<b style="font-weight:500">Glynnis</b> you have a unique opportunity to strengthen client relationships by engaging in meaningful conversations, understanding their business goals.',
          actionName1:
            'RMs with a 3.5+ on Depth of Relationships consistently achieve 20% higher Account Growth than the average.',
          actionName2:
            'By focusing on deepening relationships, you can double your Relationship Depth Score from 1.5 to 3, leading to Accounts Growth of 18% next quarter.',
          course: 'Relationship Depth',
        },
      ],
      title: 'Competencies',
      battleCardType: 'Learning Battlecards',
      driver1_max_value: 5,
      driver2_max_value: 99,
      driver3_max_value: 30.75,
      driver1_min_value: 1,
      driver1_mean_value: 3.45,
      driver2_mean_value: 60.41,
      driver3_mean_value: 13.26,
      org_driver_max_value: 5,
      org_driver_min_value: 1,
    },
    {
      name: 'Steffane Doerffer',
      userId: 'Steffane Doerffer',
      battleCardData: [
        {
          title: 'Competencies',
          name: 'Relationship Depth',
          value: 4,
          valueType: 'discrete',
          original_top_driver: 'Technical Skills',
          predicted_outcome: '41.92',
          org_driver_mean_value: 3.45,
          X_poor_org_driver_value: 1.5,
          X_good_org_driver_value: 4,
        },
        {
          title: 'Activity',
          name: 'Product Knowledge / Bundling Score',
          value: 80,
          valueType: 'continuous',
        },
        {
          title: 'Time Allocation',
          name: 'With Customer',
          value: 28.71,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [],
      title: 'Competencies',
      battleCardType: 'Learning Battlecards',
      driver1_max_value: 5,
      driver2_max_value: 99,
      driver3_max_value: 30.75,
      driver1_min_value: 1,
      driver1_mean_value: 3.45,
      driver2_mean_value: 60.41,
      driver3_mean_value: 13.26,
      org_driver_max_value: 5,
      org_driver_min_value: 1,
    },
  ],
};

export const penny_elsey = {
  battleCard: [
    {
      name: 'Penny Bumpus',
      userId: '62056408-383a-4e84-8c98-f6778803ad96',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Meetings w/ Agenda (%)',
          value: 29,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '32.81',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 12,
          X_good_org_driver_value: 67,
        },
        {
          title: 'Activity',
          name: 'Pipeline Discipline',
          value: 27,
          valueType: 'continuous',
        },
        {
          title: 'Competencies',
          name: 'Discovery skills',
          value: 1.2,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to spend more time w/ product teams',
          actionName:
            '<b>Penny</b>, well planned conversations are your accelerator for Deposits Growth',
          actionName1:
            'RMs with 58%+ of meetings that follow a clear agenda see 15% higher Deposits Growth.',
          actionName2:
            'Doubling your meetings with an agenda from 29% to 58%, could drive up Deposits Growth to 34% next quarter.',
          course: 'Meetings w/ Agenda (%)',
        },
      ],
      title: 'Time Allocation',
      battleCardType: 'Time Allocation Battlecards',
      driver1_max_value: 100,
      driver2_max_value: 42,
      driver3_max_value: 4.9,
      driver1_mean_value: 58,
      driver2_mean_value: 29.46,
      driver3_mean_value: 2.47,
    },
    {
      name: 'Elsey Hickisson',
      userId: 'Elsey Hickisson',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Meetings w/ Agenda (%)',
          value: 90,
          valueType: 'continuous',
        },
        {
          title: 'Activity',
          name: 'Pipeline Discipline',
          value: 31,
          valueType: 'continuous',
        },
        {
          title: 'Competencies',
          name: 'Discovery skills',
          value: 3.1,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [],
      title: 'Time Allocation',
      battleCardType: 'Time Allocation Battlecards',
      driver1_max_value: 100,
      driver2_max_value: 42,
      driver3_max_value: 4.9,
      driver1_mean_value: 58,
      driver2_mean_value: 29.46,
      driver3_mean_value: 2.47,
    },
  ],
};
